class FavouriteProduct extends HTMLElement {
  constructor() {
    super();

    this.analytics = this.querySelector('.js-analytics') ? JSON.parse(this.querySelector('.js-analytics').innerHTML) : '';
  }

  connectedCallback() {
    this.addEventListener('click', this.clickOnFavouriteProduct)
  }

  async clickOnFavouriteProduct() {
    if (this.getAttribute('href')) {
      document.querySelector('[data-login-redirect]').value = '/pages/a-propos-de-nos-livres?view=favourite_product'
    }
    else {
      this.updateVariableFavouriteProducts()
      this.updateHeartFavouriteProduct()
      await this.updateCustomerMetafields()
    }
  }

  updateVariableFavouriteProducts() {
    this.isProductAdded = !this.querySelector('svg').classList.contains('jc-fill-electricViolet');
  
    if (this.isProductAdded) {
      window.favouriteProducts.push(this.dataset.favouriteProductId);
  
      // Call pushDataLayer after 1 second if the product is added
      setTimeout(() => {
        if(this.isProductAdded)
          this.pushDataLayer();
      }, 1000);
    } else {
      window.favouriteProducts = window.favouriteProducts.filter(productId => productId != this.dataset.favouriteProductId);
    }
  }

  updateHeartFavouriteProduct() {
    if (this.querySelector('svg').classList.contains('jc-fill-electricViolet')) {
      document.querySelectorAll(`[data-favourite-product-id="${this.dataset.favouriteProductId}"] svg`).forEach(favourite => {
        favourite.classList.remove('jc-fill-electricViolet', 'jc-text-electricViolet')
        favourite.classList.add('jc-fill-transparent');
      })
    }
    else {
      document.querySelectorAll(`[data-favourite-product-id="${this.dataset.favouriteProductId}"] svg`).forEach(favourite => {
        favourite.classList.add('jc-fill-electricViolet', 'jc-text-electricViolet')
        favourite.classList.remove('jc-fill-transparent');
      })
    }
  }

  async updateCustomerMetafields() {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      "rout": "favouritesBook",
      "favouriteProductIds": window.favouriteProducts,
      'visitorId': localStorage.getItem("visitorId"),
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    await fetch(window.Shopify.routes.root + "apps/search", requestOptions)
      .then((response) => response.text())
      .then((result) => result)
      .catch((error) => console.error(error));
  }

  pushDataLayer() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_to_wishlist_ta',  
      location: theme.pageType,
      ecommerce: {
        items: [
          {
            item_id: this.analytics.item_id,
            item_variant: this.analytics.item_variant,
            item_variant_id: this.analytics.item_variant_id,
            item_variant_title: this.analytics.item_variant_title,
            item_product_id: this.analytics.item_product_id,
            item_product_title: this.analytics.item_product_title,
            item_name: this.analytics.item_name,
            discount: this.analytics.discount,
            price: this.analytics.price,
            item_brand: this.analytics.item_brand,
            item_category: this.analytics.item_category,
            item_list_id: this.analytics.item_list_id,
            item_list_name: this.analytics.item_list_name,
            sku: this.analytics.sku
          }
        ]
      }
    });
  }
}

customElements.define("favourite-product", FavouriteProduct);